import { ROOT_MEDIA } from 'shared-base';

export const sceneItems: ISceneItems = {
  i1: {
    id: 'i1',
    generatorId: 'G-232',
    position: [0, 0, 0],
    rotation: [0, 90, 0],
    scale: 0.65,
    url: `${ROOT_MEDIA}/glbs/scene/G-232.glb`,
  },
  i2: {
    id: 'i2',
    generatorId: 'G-091',
    position: [-2.5, 0, 1],
    rotation: [0, -90, 0],
    scale: 1.2,
    url: `${ROOT_MEDIA}/glbs/scene/G-091.glb`,
  },
  i3: {
    id: 'i3',
    generatorId: 'G-234',
    position: [-1, 0, -2.5],
    rotation: [0, 180, 0],
    scale: 1,
    url: `${ROOT_MEDIA}/glbs/scene/G-234.glb`,
  },
  i4: {
    id: 'i4',
    generatorId: 'G-414',
    position: [1.5, 0, -2.5],
    rotation: [0, 0, 0],
    scale: 1,
    url: `${ROOT_MEDIA}/glbs/scene/G-414.glb`,
  },
  // i5: {
  //   id: 'i5',
  //   generatorId: 'G-101',
  //   position: [1.5, 0, -2.5],
  //   rotation: [0, 0, 0],
  //   scale: 1,
  //   url: `${ROOT_MEDIA}/glbs/scene/G-101.glb`,
  // },
  // i6: {
  //   id: 'i6',
  //   generatorId: 'G-149',
  //   position: [1.5, 0, -2.5],
  //   rotation: [0, 0, 0],
  //   scale: 1,
  //   url: `${ROOT_MEDIA}/glbs/scene/G-414.glb`,
  // },
};
